export default {
  businessOutcome: 'Business Outcome',
  adHocEvaluation: 'Was an ad-hoc evaluation performed for this experiment?',
  generalComments: 'General comments',
};